import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const serverActionService = {
  getActions: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/admin/server-action`, getAxiosOptions(user))).data
  },
  getActionTranslations: async (user, actionId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/server-action/translations/${actionId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  saveActionTranslations: async (user, translations) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/server-action/translations`,
        translations,
        getAxiosOptions(user),
      )
    ).data
  },
  saveInboundActionTranslations: async (user, translations) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/server-action/inbound/translations`,
        translations,
        getAxiosOptions(user),
      )
    ).data
  },
  getInboundActionTranslations: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/server-action/inbound/translations/${activityTemplateId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  deleteAction: async (user, actionId) => {
    return (
      await axios.delete(`${NODE_BASE_URL}/admin/server-action/${actionId}`, getAxiosOptions(user))
    ).data
  },
  deleteActionTranslation: async (user, translationId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/server-action/translations/${translationId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  addNewAction: async (user, action) => {
    return (await axios.post(`${NODE_BASE_URL}/admin/server-action`, action, getAxiosOptions(user)))
      .data
  },
}
